import { DocumentsState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

const initialState: DocumentsState = {
    request: {
        status: AsyncStateStatus.INITIAL,
        result: [],
        type: '',
    },
    itens: {
        status: AsyncStateStatus.INITIAL,
        notas: []
    },
    danfe: {
        status: AsyncStateStatus.INITIAL,
    }
}

export const documentsSlice = createSlice({
    name: '@documents',
    initialState,
    reducers: {
        documentsRequest: (state: Draft<DocumentsState>) => {
            state.request.status = AsyncStateStatus.LOADING
        },
        documentsSuccess: (state: Draft<DocumentsState>, action: PayloadAction<{ data: any, type: string } >) => {
            state.request.status = AsyncStateStatus.SUCCESS
            state.request.result = action.payload.data
            state.request.type = action.payload.type
        },
        documentsFailure: (state: Draft<DocumentsState>) => {
            state.request.status = AsyncStateStatus.FAILURE
            state.request.result = []
        },
        documentsCancel: (state: Draft<DocumentsState>) => {
            state.request.status = AsyncStateStatus.INITIAL
            state.request.result = []
        },
        itensRequest: (state: Draft<DocumentsState>) => {
            state.itens.status = AsyncStateStatus.LOADING
        },
        itensSuccess: (state: Draft<DocumentsState>, action: PayloadAction<{ data: any} >) => {
            state.itens.status = AsyncStateStatus.SUCCESS
            state.itens.notas = action.payload.data.notas
        },
        itensFailure: (state: Draft<DocumentsState>) => {
            state.itens.status = AsyncStateStatus.FAILURE
        },
        danfeRequest: (state: Draft<DocumentsState>) => {
            state.danfe.status = AsyncStateStatus.LOADING
        },
        danfeSuccess: (state: Draft<DocumentsState>) => {
            state.danfe.status = AsyncStateStatus.SUCCESS
        },
        danfeFailure: (state: Draft<DocumentsState>) => {
            state.danfe.status = AsyncStateStatus.FAILURE
        },

    }
})

/**
 * <h5>Functions that trigger actions related to authentication in the system.</h5>
 * @see {@link https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions}
 * @typedef DocumentsActions
 * @namespace DocumentsActions
 * @category React
 * @subcategory Redux / Actions
 * @property {Function} documentsRequest
 * @property {Function} documentsSuccess
 * @property {Function} documentsFailure
 * @property {Function} itensRequest
 * @property {Function} itensSuccess
 * @property {Function} itensFailure
 */
export const DocumentsActions = documentsSlice.actions

export default documentsSlice.reducer
